import { ApiAuth } from "../../_services/api";

/**
 * GEN-3604 — teto padrão das chamadas que a lib do portal faz pela ponte.
 *
 * O `ApiAuth()` cru da plataforma vem com 20 min de timeout (herança dos uploads grandes). No portal
 * isso é o tempo que uma busca/preview/pedido pendurado deixa o spinner girando antes de qualquer
 * mensagem. 60 s cobre tudo que responde em segundos; o export (XLSX/ZIP com N arquivos do S3) é a
 * única operação que legitimamente passa disso e a lib pede o próprio teto via `overrides`.
 */
export const PORTAL_API_TIMEOUT_MS = 60_000;

/** O que a lib pode ajustar por operação. Espelha `HostApiAuthOverrides` da `@taxlybr/autosservico-web`. */
export interface PortalApiAuthOverrides {
  timeout?: number;
}

/**
 * Contrato da ponte: `ApiAuth(overrides?)` devolve a config autenticada do host (headers com a sessão,
 * lidos NA CHAMADA — o token não fica preso na ponte memoizada) com `timeout` de 60 s por padrão,
 * e `overrides` por cima. Diferente do `ApiAuth(add)` da plataforma, o argumento aqui NÃO é headers
 * extras — é config do axios. A lib (a partir da 0.1.3) também aplica o próprio timeout por
 * operação sobre o retorno, então uma ponte antiga sem este teto não a quebra; este padrão é a rede
 * de segurança para qualquer chamada que a lib faça sem pedir teto.
 */
export const portalApiAuth = (overrides?: PortalApiAuthOverrides) => ({
  ...ApiAuth(),
  timeout: overrides?.timeout ?? PORTAL_API_TIMEOUT_MS,
});
